export const CATEGORY_LEVEL_0 = 'hierarchical_categories.lvl0';
export const CATEGORY_LEVEL_1 = 'hierarchical_categories.lvl1';
export const CATEGORY_LEVEL_2 = 'hierarchical_categories.lvl2';
const CATEGORY_LEVEL_3 = 'hierarchical_categories.lvl3';
const CATEGORY_LEVEL_4 = 'hierarchical_categories.lvl4';

export const CATEGORY_ATTRIBUTES = [
    CATEGORY_LEVEL_0,
    CATEGORY_LEVEL_1,
    CATEGORY_LEVEL_2,
    CATEGORY_LEVEL_3,
    CATEGORY_LEVEL_4,
];
